import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as camerasActions from '../../../../redux/actions/camerasManagementAction';
import { camerasSortOptions } from '../../../../constants/camerasSettings.constants';
import { SortFilter } from '../../../../components/Filters';

const CameraSettingsSidebarSort = () => {
  const dispatch = useDispatch();
  const sortBy = useSelector(state => state.camerasManage.settings.sortBy);
  const orderDirection = useSelector(state => state.camerasManage.settings.orderDirection);
  
  const changeValue = useCallback((key, value) => {
    dispatch(camerasActions.changeSettingsValue(key, value));
  }, []);
  
  return (
    <SortFilter
      sortBy={sortBy}
      direction={orderDirection}
      options={camerasSortOptions}
      changeValue={changeValue}
    />
  );
};

export default CameraSettingsSidebarSort;